export default "__VITE_ASSET__167afa3d__"